import { render, staticRenderFns } from "./PackageSearchItem.vue?vue&type=template&id=40f3faa6&scoped=true&"
import script from "./PackageSearchItem.vue?vue&type=script&lang=js&"
export * from "./PackageSearchItem.vue?vue&type=script&lang=js&"
import style0 from "./PackageSearchItem.vue?vue&type=style&index=0&id=40f3faa6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3faa6",
  null
  
)

export default component.exports